import isThrottled from './isThrottled';
import nextTick from './nextTick';
import {logDeferTiming} from './deferMetrics';

export default function defer(fn, duration = 0) {
	logDeferTiming(duration);
	return isThrottled() ? nextTick(fn) : setTimeout(fn, duration);
}
